import { createStore } from 'vuex'

import app from './modules/app'
import discount from './modules/discount'
import promocode from './modules/promocode'

const debug = process.env.NODE_ENV !== 'production'

const store = createStore({
    modules: {
        app,
        discount,
        promocode,
    },
    strict: debug,
})

export default store